import { LocationTypes } from '@kinetic-ui/shared';
import { useParams } from 'react-router-dom';

export const useCreateLocationActionRouteParams = () => {
  return useParams<{ defaultLocationType?: LocationTypes }>();
};
